import { useUserStore } from '~/store/user'
import type { Module } from '~/codebooks/acl/Module'
import type { Privilege } from '~/codebooks/acl/Privilege'
import { ModuleLevel } from '~/codebooks/acl/ModuleLevel'
import { PrivilegeLevel } from '~/codebooks/acl/PrivilegeLevel'

export class ModuleCheck {
  static hasAccess(module: Module): boolean {
    return this.checkAccess(module)
  }

  static hasAccessAll(...modules: Module[]): boolean {
    if (modules.length === 0) {
      return false
    }

    return modules.flat().every((m) => this.checkAccess(m))
  }

  static hasAccessLeastOne(...modules: Module[]): boolean {
    if (modules.length === 0) {
      return false
    }

    return modules.flat().some((m) => this.checkAccess(m))
  }

  private static checkAccess(module: Module): boolean {
    const acl = useUserStore().user.acl

    if (acl.modulesLevel === ModuleLevel.ALL) {
      return true
    }

    return acl.modules.includes(module)
  }
}

export class PrivilegeCheck {
  static hasPrivilege(privilege: Privilege): boolean {
    return this.checkPrivilege(privilege)
  }

  static hasPrivilegeAll(...privileges: Privilege[]): boolean {
    if (privileges.length === 0) {
      return false
    }

    return privileges.flat().every((privilege: Privilege) => this.checkPrivilege(privilege))
  }

  static hasPrivilegeLeastOne(...privileges: Privilege[]): boolean {
    if (privileges.length === 0) {
      return false
    }

    return privileges.flat().some((privilege: Privilege) => this.checkPrivilege(privilege))
  }

  private static checkPrivilege(privilege: Privilege): boolean {
    const acl = useUserStore().user.acl

    if (acl.privilegesLevel === PrivilegeLevel.ALL) {
      return true
    }

    return acl.privileges.includes(privilege)
  }
}
